export const LANG_FR = 'fr'
export const LANG_EN = 'en'
